module.exports = __webpack_public_path__ + "img/IMG_9635.be998a74.jpg";